/**
 * Pushes an event to the data layer when the edit recipes button is clicked.
 * This is used for analytics tracking.
 * @return {void}
 */
export function pushEditRecipesClick(): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'edit_recipes_click',
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: edit_recipes_click', datalayerObject);
	}
}
